import React, { useEffect, useState } from 'react';
import { Button, View } from '../../../../core/components/Index';
import { useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { generateStepArray } from './Utils';
import { BrowserRouter as Router, Outlet } from 'react-router-dom';
import { FormProvider, useForm } from './FormContext';
import GettingStarted from './1_0_GettingStarted';
import ReviewApplication from './10_0_ReviewApplication';
import UploadDocuments from './11_0_UploadDocuments';
import SidebarFormNavigation, { Step, StepStatus } from './SidebarFormNavigation';
import SelectDate from './2_0_SelectDate';
import { useLocation } from 'react-router-dom';
import PersonalInformation from './3_1_PersonalInformation';
import ContactInfo from './3_3_ContactInfo';
import PersonalStatus from './3_4_PersonalStatus';
import OptionSelection from './4_0_OptionSelection';
import OptionSelectionMemberDeclaration from './4_1_OptionSelection_MemberDeclaration';
import BeneficiaryDesignationBurialAllowance from './5_3_BeneficiaryDesignationBurialAllowance';
import FederalTaxWitholding from './6_1_Federal';
import StateTaxWithholding from './6_2_State';
import TaxWithholdingDeclaration from './6_3_TaxDeclaration';
import ApplyViewModel from './ApplyViewModel';
import BeneficiaryBenefit from './5_2_BeneficiaryBenefit';
import SraModule from '../OraModule';
import { Steps } from './ApplyModels';
import DirectDepositAuthorization from './7_1_DirectDepositAuthorization';
import ServiceRetirementSignOff from './9_0_ServiceRetirementSignOff';
import SubmitApplication from './12_0_SubmitApplication';
import { Appl } from '../../../../core/Appl';
import RetirementOverview from './ResumeApplication';
import TemporaryAnnuity from './8_0_TemporaryAnnuity';
import DirectDepositMemberDeclaration from './7_2_DirectDepositMemberDeclaration';
import BeneficiaryDesignationUnderstandingBeneficiaries from './5_1_BeneficiaryDesignationUnderstandingBeneficiaries';
import AddressInformation from './3_2_AddressInformation';
import { SubmissionStatusView } from './12_1_SubmissionStatusView';
import { SubmissionStatus } from '../OraEnums';

function useActiveStep(steps: Step[], stepArray: any, location: any) {
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const findMatchingStep = (steps: Step[]): { activePage: Step | null; nextStep: any; activeSubPage: Step['subSteps'][0] | null } => {
    for (const step of steps) {
      if (pathSegments.includes(step.slug)) {
        let nextSlug = stepArray.findIndex((s: any) => s.slug === step.slug);

        const subStep = step.subSteps?.find((sub) => pathSegments.includes(sub.slug)) || null;
        if (subStep) {
          nextSlug = stepArray.findIndex((s: any) => s.slug === step.slug);
        }
        //find index of step or if set substep in stepArray by slug and return it then +1 to get the next step
        return { activePage: step, activeSubPage: subStep, nextStep: nextSlug ? stepArray[nextSlug + 1] : stepArray[1] };
      }
    }
    return { activePage: null, activeSubPage: null, nextStep: stepArray[0] };
  };

  const { activePage, activeSubPage, nextStep } = findMatchingStep(steps);

  return { activePage, activeSubPage, nextStep };
}


const WizardContent: React.FC<{
  activePage: Step | null;
  activeSubPage: Step['subSteps'][0] | null;
  handleNext: (index: number, onStepChange: any) => void;
  handleBack: () => void;
  handleNextStep: () => void;
  isLoading: boolean;
  formData: any;
}> = React.memo(({
  activePage,
  activeSubPage,
  handleNext,
  handleBack,
  handleNextStep,
  isLoading,
  // formData
}) => {
  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {activePage?.navigatedFromReviewScreen && <div className="gap-4 p-6 border-[2px] border-orange-500 bg-[#fbf5ef] flex rounded-md mb-4" >
        <div><svg viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg" className='w-7 h-7'>
          <path d="M14.4989 0.5C15.3033 0.5 16.0453 0.918527 16.4532 1.60491L28.6884 22.1406C29.1019 22.8326 29.1019 23.6864 28.6998 24.3783C28.2976 25.0703 27.5442 25.5 26.7342 25.5H2.2637C1.45368 25.5 0.700303 25.0703 0.298126 24.3783C-0.104051 23.6864 -0.0983867 22.827 0.309455 22.1406L12.5447 1.60491C12.9525 0.918527 13.6946 0.5 14.4989 0.5ZM14.4989 7.64286C13.7456 7.64286 13.1395 8.23996 13.1395 8.98214V15.2321C13.1395 15.9743 13.7456 16.5714 14.4989 16.5714C15.2523 16.5714 15.8584 15.9743 15.8584 15.2321V8.98214C15.8584 8.23996 15.2523 7.64286 14.4989 7.64286ZM16.3116 20.1429C16.3116 19.6693 16.1206 19.2151 15.7807 18.8802C15.4407 18.5453 14.9797 18.3571 14.4989 18.3571C14.0182 18.3571 13.5572 18.5453 13.2172 18.8802C12.8773 19.2151 12.6863 19.6693 12.6863 20.1429C12.6863 20.6165 12.8773 21.0707 13.2172 21.4055C13.5572 21.7404 14.0182 21.9286 14.4989 21.9286C14.9797 21.9286 15.4407 21.7404 15.7807 21.4055C16.1206 21.0707 16.3116 20.6165 16.3116 20.1429Z" fill="#CF7119" />
        </svg>
        </div>
        <div className='-mt-1'>
          <div className='text-orange-500 text-22px font-semibold mb-1 tracking--1percent'>You Are Making a Change to Your Application</div>
          <p className="text-black text-15px tracking--1_5percent  ">
            You're updating part of your application. If you're changing your retirement date, marital status, or benefit option, we may ask you to re-enter info in other sections too. These details are connected and help us make sure your benefits are calculated correctly.
            <br /><br />If you don't wish to make any changes and want to go back, just click 'Cancel & Return to Review' to head back to your application summary.
          </p>
        </div>
      </div>
      }
      <Outlet />
      <div className="my-3 flex space-x-4">
        {(activeSubPage && activeSubPage.hideNextButton) || (!activeSubPage && activePage?.hideNextButton) ? null : (
          <Button
            rounded
            onClick={() => {
              if (activeSubPage && activeSubPage.onStepChange) {
                handleNext(1, activeSubPage.onStepChange);
              } else if (activePage && activePage.onStepChange) {
                handleNext(1, activePage.onStepChange);
              } else {
                handleNextStep();
              }
            }}
            label={
              activeSubPage?.nextButtonLabel
                ? activeSubPage?.nextButtonLabel
                : activePage?.nextButtonLabel
                  ? activePage.nextButtonLabel
                  : 'Save & Continue'
            }
          />
        )}

        {(activeSubPage && activeSubPage.hideCancelButton) || (!activeSubPage && activePage?.hideCancelButton) ? null : (
          <Button
            outlined
            severity="warning"
            label={
              activeSubPage?.cancelButtonLabel
                ? activeSubPage?.cancelButtonLabel
                : activePage?.cancelButtonLabel
                  ? activePage.cancelButtonLabel
                  : 'Cancel'
            }
            onClick={() => handleBack()}
          />
        )}
      </div>
      {(activePage?.submitted || Steps.GettingStarted === activePage?.slug || document.location.href.toLowerCase().includes(Steps.SubmitApplication)) ? null : <p className='text-black text-15px tracking--1_5percent -mt-2'>You can <a
        className='text-primary-500 underline cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 rounded-sm px-0.5'
        tabIndex={0}
        role="button"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            Appl.ConfirmBox.show('Are you sure you want to exit the application?<br/><br/>You can return to this page at any time, and all completed sections will be saved. However, any information entered on this page that has not been saved will be lost.', 'Exit Confirmation', '', 'Yes, I am sure', 'Cancel', () => { location.href = Appl.Setting.MyScersPortalUrl }, undefined, true);
          }
        }}
        onClick={() => Appl.ConfirmBox.show('Are you sure you want to exit the application?<br/><br/>You can return to this page at any time, and all completed sections will be saved. However, any information entered on this page that has not been saved will be lost.', 'Exit Confirmation', '', 'Yes, I am sure', 'Cancel', () => { location.href = Appl.Setting.MyScersPortalUrl }, undefined, true)}>Exit the Application</a> and come back to any completed section. Be aware that any changes not saved will be lost.</p>
      }

    </>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.activePage?.slug === nextProps.activePage?.slug &&
    prevProps.activeSubPage?.slug === nextProps.activeSubPage?.slug &&
    prevProps.isLoading === nextProps.isLoading &&
    prevProps.formData?.errors === nextProps.formData?.errors
  );
});


const WizardLayout = ({ retirementSteps }: { retirementSteps: Step[] }) => {
  const { formData, updateFormData } = useForm();
  const stepArray = generateStepArray(retirementSteps);

  useEffect(() => {
    updateFormData('retirementSteps', retirementSteps);
    updateFormData('stepsFlatList', stepArray);
  }, [retirementSteps]);

  // }, [submissionId]);
  const location = useLocation();
  const { activePage, activeSubPage, nextStep } = useActiveStep(retirementSteps, stepArray, location);

  useEffect(() => {
    updateFormData('activeStep', activePage);
    updateFormData('activeSubStep', activeSubPage);
    updateFormData(
      'activeStepNumber',
      retirementSteps.findIndex((s: any) => s.slug === activePage?.slug),
    );
  }, [activePage, activeSubPage]);

  const navigate = useNavigate();

  const handleBack = () => {
    const prevStepIndex = stepArray.findIndex((s: any) => s.slug.includes(activeSubPage?.slug ? activeSubPage.slug : activePage?.slug)) - 1;
    const prevStep = stepArray[prevStepIndex];
    navigate(prevStep.slug);
  };

  const handleNext = async (index: number, onStepChange: any) => {
    if (typeof onStepChange === 'function') {
      const valid = await onStepChange();
      if (valid) {
        handleNextStep();
      } else {
        // alertService.showError("Validation failed")
        // updateFormData('errors', 'Validation failed');
      }
    }
  };

  const handleNextStep = () => {
    const nextStepIndex = stepArray.findIndex((s: any) => s.slug.includes(activeSubPage?.slug ? activeSubPage.slug : activePage?.slug)) + 1;
    const nextStep = stepArray[nextStepIndex];
    navigate(nextStep.slug);
  };

  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   // Simulate loading time for the route change
  //   setIsLoading(true);
  //   const timer = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 10);

  //   return () => clearTimeout(timer);
  // }, [location.pathname]);

  // Scroll to page title on route change
  useEffect(() => {
    const scrollToPageTitle = () => {
      // Check if we're on mobile (screen width less than 768px)
      const isMobile = window.innerWidth < 768;
      
      if (isMobile) {
        // On mobile, scroll to content div to account for navigation space
        const contentDiv = document.getElementById('content');
        if (contentDiv) {
          const rect = contentDiv.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const targetScrollTop = scrollTop + rect.top;
          
          window.scrollTo({ 
            top: targetScrollTop, 
            behavior: 'smooth' 
          });
        }
      } else {
        // On desktop, just scroll to top
        window.scrollTo({ 
          top: 0, 
          behavior: 'smooth' 
        });
      }
    };
    // Small delay to ensure the new page content is rendered
    const timer = setTimeout(scrollToPageTitle, 50);
    return () => clearTimeout(timer);
 
  }, [location.pathname]);

  return (
    <div className="mx-auto px-6 lg:px-12 py-4">
      <div className="flex flex-wrap md:flex-nowrap">
        <div className="w-[320px] flex-shrink-0 md:pr-12">
          <p className="text-22px font-semibold text-neutral-800 mb-4">Apply for Retirement</p>
          <SidebarFormNavigation retirementSteps={retirementSteps} />
        </div>
        <div className='max-w-[1000px]' id="content">
          {formData.errors && formData.errors.length > 0 && (
            <div className="bg-red-500 text-white p-2 mb-4 text-sm rounded-xl text-center">
              {JSON.stringify(formData.errors)}
            </div>
          )}
          
          <WizardContent
            activePage={activePage}
            activeSubPage={activeSubPage}
            handleNext={handleNext}
            handleBack={handleBack}
            handleNextStep={handleNextStep}
            isLoading={isLoading}
            formData={formData}
          />
        </div>
      </div>
    </div>
  );
}


const RetirementApplicationLayout: React.FC = observer(() => {
  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');


  vm.navigate = useNavigate();
  const retirementSteps: Step[] = [
    {
      step: 'Getting Started',
      slug: Steps.GettingStarted,
      element: <GettingStarted />,
      nextButtonLabel: 'Continue',
      hideCancelButton: true,
      onStepChange: async () => await vm.onGettingStartedStepChangeAsync(),
      status: vm.stepStatus.gettingStarted as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [],
    },
    {
      step: 'Retirement Date',
      slug: Steps.SelectDate,
      element: <SelectDate />,
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.stepStatus.selectDate as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [],
    },
    {
      step: 'Your Information',
      slug: Steps.YourInformation,
      element: <Navigate to={Steps.PersonalInformation} replace={true} />,
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.stepStatus.yourInformation as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [
        {
          subStep: 'Personal Information',
          slug: Steps.PersonalInformation,
          element: <PersonalInformation />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.personalInformation as StepStatus,
        },
        {
          subStep: 'Address Information',
          slug: Steps.AddressInformation,
          element: <AddressInformation />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.addressInformation as StepStatus,
        },
        {
          subStep: 'Contact Information',
          slug: Steps.ContactInformation,
          element: <ContactInfo />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.contactInformation as StepStatus,
        },
        {
          subStep: 'Personal Status',
          slug: Steps.PersonalStatus,
          element: <PersonalStatus />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.personalStatus as StepStatus,
        }
      ],
    },
    {
      step: 'Option Election',
      slug: Steps.OptionSelection,
      element: <Navigate to={Steps.OptionSelectionSelectYourOption} replace={true} />,
      nextButtonLabel: 'Save & Continue',
      cancelButtonLabel: 'Cancel',
      status: vm.stepStatus.optionSelection as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [
        {
          subStep: 'Select Your Option',
          slug: Steps.OptionSelectionSelectYourOption,
          element: <OptionSelection />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.optionSelectionSelectYourOption as StepStatus,
        },
        {
          subStep: 'Member Declaration',
          slug: Steps.OptionSelectionMemberDeclaration,
          element: <OptionSelectionMemberDeclaration />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.optionSelectionMemberDeclaration as StepStatus,
        }
      ]
    },
    {
      step: 'Beneficiary Designation',
      slug: Steps.BeneficiaryDesignation,
      element: <Navigate to={Steps.UnderstandingBeneficiaries} replace={true} />,
      status: vm.stepStatus.beneficiaryDesignation as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [
        {
          subStep: 'Understanding Beneficiaries',
          slug: Steps.UnderstandingBeneficiaries,
          element: <BeneficiaryDesignationUnderstandingBeneficiaries />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.beneficiaryDesignation as StepStatus,
        },
        {
          subStep: 'Retirement Benefit',
          slug: Steps.BeneficiaryBenefit,
          element: <BeneficiaryBenefit />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.beneficiaryBenefit as StepStatus,
        },
        {
          subStep: 'Burial Allowance',
          slug: Steps.BeneficiaryBurialAllowance,
          element: <BeneficiaryDesignationBurialAllowance />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.beneficiaryBurialAllowance as StepStatus,
        },
      ],
    },
    {
      step: 'Tax Withholding',
      slug: Steps.TaxWithholding,
      element: <Navigate to={Steps.FederalTaxWithholding} replace={true} />,
      status: vm.stepStatus.taxWithholding as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [
        {
          subStep: 'Federal Tax Withholding',
          slug: Steps.FederalTaxWithholding,
          element: <FederalTaxWitholding />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.federalTaxWithholding as StepStatus,
        },
        {
          subStep: 'CA State Tax Withholding',
          slug: Steps.StateTaxWithholding,
          element: <StateTaxWithholding />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.stateTaxWithholding as StepStatus,
        },
        {
          subStep: 'Member Declaration',
          slug: Steps.DeclarationTaxWithholding,
          element: <TaxWithholdingDeclaration />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.declarationTaxWithholding as StepStatus,
        },
      ],
    },
    {
      step: 'Direct Deposit',
      slug: Steps.DirectDeposit,
      element: <Navigate to={Steps.DirectDepositAuthorization} replace={true} />,
      nextButtonLabel: 'Start Section',
      status: vm.stepStatus.directDeposit as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [
        {
          subStep: 'Account Information',
          slug: Steps.DirectDepositAuthorization,
          element: <DirectDepositAuthorization />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.directDepositAuthorization as StepStatus,
        },
        {
          subStep: 'Member Declaration',
          slug: Steps.DirectDepositMemberDeclaration,
          element: <DirectDepositMemberDeclaration />,
          hideNextButton: true,
          hideCancelButton: true,
          status: vm.stepStatus.directDepositMemberDeclaration as StepStatus,
        }
      ],
    },
    {
      step: 'Temporary Annuity',
      slug: Steps.TemporaryAnnuity,
      element: <TemporaryAnnuity />,
      nextButtonLabel: 'Save & Continue',
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.stepStatus.temporaryAnnuity as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: []
    },
    {
      step: 'Retirement Sign-Off',
      slug: Steps.ServiceRetirementSignOff,
      element: <ServiceRetirementSignOff />,
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.stepStatus.serviceRetirementSignOff as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      disabled: vm.model.personalInformation.appSelfReviewed === 'Y',
      subSteps: [],
    },
    {
      step: 'Review Application',
      slug: Steps.ReviewApplication,
      element: <ReviewApplication />,
      // nextButtonLabel: 'Save & Continue',
      hideNextButton: true,
      hideCancelButton: true,
      // onStepChange: async () => await vm.onReviewApplicationStepChangeAsync(),
      status: vm.stepStatus.reviewApplication as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      subSteps: [],
    },
    {
      step: 'Upload Documents',
      slug: Steps.UploadDocuments,
      element: <UploadDocuments />,
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.stepStatus.uploadDocuments as StepStatus,
      navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      subSteps: [],
    },
    {
      step: vm.submission?.lovSubmissionStatusId === SubmissionStatus.Submitted ? 'Application Submitted' : 'Submit Application',
      slug: Steps.SubmitApplication,
      element: vm.submission?.lovSubmissionStatusId === SubmissionStatus.Submitted ? <SubmissionStatusView /> : <SubmitApplication />,
      hideNextButton: true,
      hideCancelButton: true,
      status: vm.submission?.lovSubmissionStatusId === SubmissionStatus.Submitted ? StepStatus.Completed : vm.stepStatus.submitApplication as StepStatus,
      // navigatedFromReviewScreen: vm.navigatedFromReviewScreen,
      navigatedFromReviewScreen: false,
      subSteps: [],
      submitted: vm.submission?.lovSubmissionStatusId === SubmissionStatus.Submitted
    },
  ];

  return (
    <>
      <View
        id="RetirementApplicationLayout"
        showMenuBar={false}
        menuItems={SraModule.MenuItems()}
        style={{ backgroundColor: '#fff' }}
        className='py-4 min-h-svh-header'
        container={false}>

        <FormProvider>
          <Routes>
            <Route index element={<div className="px-6 md:px-12 py-4">
              <div className='max-w-5xl '>
                <h1 className="text-32px tracking--1percent font-semibold text-black mb-4">Apply For Retirement</h1>
                <p className="text-gray-800 mb-8 text-15px tracking--1percent">
                  You can resume your retirement application from where you last left off. Completed sections are marked with a check, the
                  section you're currently working on is highlighted, and pending steps are noted for easy reference.
                </p></div>
              <RetirementOverview retirementSteps={retirementSteps} />
            </div>} />
            <Route path="/" element={<WizardLayout retirementSteps={retirementSteps} />}>
              <Route element={<Navigate to="getting-started" />} />
              {retirementSteps.map((step, index) => {
                return (
                  <>
                    <Route
                      key={step.slug}
                      path={step.slug + '/*'}
                      element={
                        step.element ? (
                          step.element
                        ) : (
                          <div>
                            <h1>Invalid route</h1>
                          </div>
                        )
                      }
                    />

                    {step.subSteps.map((subStep, subIndex) => {
                      return (
                        <Route
                          key={step.slug + '/' + subStep.slug + '/*'}
                          path={step.slug + '/' + subStep.slug + '/*'}
                          element={
                            subStep.element ? (
                              subStep.element
                            ) : (
                              <div>
                                <h1>Invalid route</h1>
                              </div>
                            )
                          }
                        />
                      );
                    })}
                  </>
                );
              })}
            </Route>
          </Routes>
        </FormProvider>
      </View>
    </>
  );
});
export default RetirementApplicationLayout;
